<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="chapter103">
<p class="centerImage" id="cha3"><img alt="image" id="img32" src="images/img32.jpg"/></p>
<p class="caption">(3) World Distribution of Battleships 1 January 1942</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// AttackonPearlHarbor_ch103.vue?64250cd4